import React from 'react';
import { Button, Typography } from 'antd';
import { Checkbox } from 'antd';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import {
  setDamageLocation,
  DamageLocations,
} from '../../../redux/reducers/damageLocationsSlice';
import carDiagramImg from '../../../assets/images/car-diagram.png';
import './DamageLocationStep.css';

const { Title } = Typography;

interface DamageLocationStepProps {
  onNext: () => void;
  onPrevious: () => void;
  isFirstStep: boolean;
  isLastStep: boolean;
}

const DamageLocationStep: React.FC<DamageLocationStepProps> = ({
  onNext,
  onPrevious,
}) => {
  const dispatch = useAppDispatch();
  const damageLocations = useAppSelector((state) => state.damageLocations);

  function DamageCheckbox({ location, className }: { location: DamageLocations; className?: string }) {
    const checked = damageLocations.damageLocation[location];
    return (
      <div className={`damage-checkbox-wrapper ${className || ''}`}>
        <Checkbox
          checked={checked}
          onChange={(e) =>
            dispatch(setDamageLocation({ type: location, damaged: e.target.checked }))
          }
        >
          {location}
        </Checkbox>
      </div>
    );
  }

  return (
    <div className="step-container damage-location-container">
      <Title level={5} style={{ textAlign: 'center' }}>Damage Location</Title>

      <div className="damage-location-step">
        <div
          className="damage-diagram-container"
          style={{ backgroundImage: `url(${carDiagramImg})` }}
        >
          {/* Driver side */}
          <div className="checkbox-column checkbox-column-driver">
            <DamageCheckbox location="Rear Driver Corner" />
            <DamageCheckbox location="Rear Driver Fender" />
            <DamageCheckbox location="Driver Side Door(s)" />
            <DamageCheckbox location="Front Driver Fender" />
            <DamageCheckbox location="Front Driver Corner" />
          </div>

          {/* Centre column */}
          <div className="checkbox-column checkbox-column-centre">
            <div className="centre-spacer" />
            <div className="centre-row">
              <DamageCheckbox location="Rear" />
              <DamageCheckbox location="Trunk" className="bg-checkbox" />
              <DamageCheckbox location="Roof" className="bg-checkbox wide-checkbox" />
              <DamageCheckbox location="Hood" className="bg-checkbox" />
              <DamageCheckbox location="Front" />
            </div>
            <div className="centre-spacer" />
          </div>

          {/* Passenger side */}
          <div className="checkbox-column checkbox-column-passenger">
            <DamageCheckbox location="Rear Passenger Corner" />
            <DamageCheckbox location="Rear Passenger Fender" />
            <DamageCheckbox location="Passenger Side Door(s)" />
            <DamageCheckbox location="Front Passenger Fender" />
            <DamageCheckbox location="Front Passenger Corner" />
          </div>
        </div>
      </div>

      <div className="step-actions" style={{ marginTop: 40 }}>
        <Button size="large" onClick={onPrevious} style={{ color: '#FF9902', fontWeight: 'bold' }}>PREVIOUS</Button>
        <Button type="primary" size="large" onClick={onNext} style={{ fontWeight: 'bold' }}>CONTINUE</Button>
      </div>
    </div>
  );
};

export default DamageLocationStep;
